const Style = {

  base: 'block w-[8em] h-[2em] mx-auto mb-4 outline-none select-none'

}

export default Style;
